import api from "~/services/apis/antecipeApi";

export const sendRequest = async (request) => {
  const body = {
    ...request,
    crmUf: request.crmuf,
    vacancies: request.vacancies.map((vacancie) => {
      return {
        id: vacancie.id,
        externalSystemId: vacancie.externalSystemId,
      };
    }),
  };
  return await api.post("/doctor/request", body);
};
